import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Meta } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IsrService {
    constructor(
        private meta: Meta,
        @Inject(PLATFORM_ID) private platformId: any,
        @Optional() @Inject(DOCUMENT) private document?: Document,
    ) {}

    doNotCache() {
        if (isPlatformServer(this.platformId)) {
            this.meta.addTag({ name: 'isr', content: '__isr_do_not_cache__' });
        }
    }
}
